/**
 * @voltxampere/ui — Tactile switch (PCB-mount) variant (Sprint 44-3)
 *
 * 4-terminal PCB-mount tactile switch (Omron B3F serisi mantığı).
 * 4 pin elektriksel olarak 2 çift bağlı (cross-link); şematik
 * üzerinde tek SPST-NO momentary davranışı sergiler. Mevcut
 * `switch` stamp tek terminal çifti olarak modellenir; 4-pin
 * physical layout Sprint 47+'da PCB layout view ile.
 *
 * Reference: Generic tactile switch — Omron B3F-1000, ALPS SKHH,
 * Panasonic EVQ-Q2. 50 mA @ 12 V DC, 100k cycle life. PCB push
 * button, breadboard test düğmesi, mikroservis prototipi.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const switchTactile = {
    id: "switch-tactile",
    nameTr: "Tactile Switch (PCB-mount, B3F serisi)",
    nameEn: "Tactile Switch (PCB-mount, B3F-class)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "SW",
    defaultValue: "TACT",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=switch-tactile.js.map